export default __webpack_public_path__ + "static/media/6_prestige.17d2952c.svg";